import AuthenticatedLayout from './AuthenticatedLayout';

export default AuthenticatedLayout;
